import Reveal from "@/components/base/Reveal";
import { WHATSAPP_URL } from "@/mocks/navigation";

export default function Support() {
  return (
    <section className="w-full bg-background-50" aria-label="Atendimento humanizado">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div className="relative h-[340px] w-full overflow-hidden rounded-lg bg-background-100 md:h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20lifestyle%20photo%20of%20a%20Brazilian%20fashion%20consultant%20helping%20a%20client%20choose%20clothes%20in%20a%20cozy%20boutique%20with%20neutral%20beige%20interiors%2C%20natural%20daylight%2C%20realistic%20skin%20texture%2C%20friendly%20genuine%20expressions%2C%20no%20text%2C%20no%20logos&width=1000&height=800&seq=amora-atendimento-consultora-01&orientation=landscape"
                alt="Consultora de moda da Amora Belle ajudando uma cliente a escolher as peças"
                title="Atendimento humanizado Amora Belle"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <span className="flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-accent-700">
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-heart-3-line text-[11px]" />
              </span>
              Atendimento humanizado
            </span>
            <h2 className="mt-4 font-heading text-3xl font-medium leading-tight text-foreground-900 md:text-4xl">
              Precisa de ajuda para escolher?
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              Conte para a gente o que você procura. Ajudamos você a encontrar tamanhos, combinações e peças que fazem
              sentido para o seu estilo e para a sua rotina.
            </p>

            <ul className="mt-6 flex flex-col gap-3">
              {[
                "Sugestões de looks para o seu dia a dia",
                "Orientação de tamanhos e medidas",
                "Combinação de entrega e retirada do seu jeito",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-foreground-700">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center pt-0.5">
                    <i className="ri-check-line text-base text-primary-600" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-whatsapp-line text-lg" />
              Falar com a gente
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}